var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangMdImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51515 4.93943H11.8182M6.66667 12.6667C9.79621 12.6667 12.3333 10.1296 12.3333 7.00004C12.3333 3.8705 9.79621 1.33337 6.66667 1.33337C3.53712 1.33337 1 3.8705 1 7.00004C1 10.1296 3.53712 12.6667 6.66667 12.6667ZM6.66667 12.6667C8.21212 12.6667 8.72727 10.091 8.72727 7.00004C8.72727 3.90913 8.21212 1.33337 6.66667 1.33337C5.12121 1.33337 4.60606 3.90913 4.60606 7.00004C4.60606 10.091 5.12121 12.6667 6.66667 12.6667ZM1.51515 9.06065H11.8182H1.51515Z",
    stroke: "white",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangMdImg);
export default __webpack_public_path__ + "static/media/lang_md_img.da5c28cae0f5d386c651a17297790c21.svg";
export { ForwardRef as ReactComponent };